<p-dialog
  [style]="style"
  [modal]="true"
  [(visible)]="show"
  styleClass="bgColorChange dialog "
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
<ng-template pTemplate="header">
  <div class="d-flex justify-content-between dialog__header w-100">
    <h5 class="title d-flex align-items-center">
      {{titleName}} 
    </h5>
    <div class="action" *ngIf="showEditBtn">
      <button class="btn btn-primary btn-sm btn-edit" (click)="onEdit()">
        <i class="fa fa-edit small"></i>
        <span class="">Edit</span>
      </button>
    </div>
  </div>
</ng-template>
  <div class="dialog__body">
    <ng-content select="content"></ng-content>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog__footer d-flex justify-content-end">
    <button
      type="button"
      (click)="closeDialog()"
      class="btn btn-transparent rounded">
      Cancel 
    </button>
    <button
      *ngIf="showSaveBtn"
      class="btn btn-red rounded {{disableSaveBtn?'disabled':''}}"
      (click)="saveDialog()">
      {{nameApplyBtn}}
    </button>
    </div>
  </ng-template>
</p-dialog>
